import * as angular from 'angular';
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {SurveyAlerts} from "./survey-alerts.service";
import {SurveyRequests} from "./survey-requests.service";
import {SplitService} from "../../commons/services/split-service.service";
import {ExportSurveyRequestModel} from "../models/export-survey-request.model";

export class SurveyService {

  /* @ngInject */
  constructor(private surveyRequests: SurveyRequests, private surveyAlerts: SurveyAlerts, private $q: IQService, private bringozLoaderService: BringozLoaderService,
              private $log, private splitService: SplitService) {
  }

  getTypes() {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.surveyRequests.getTypes()
      .then((types) => {
        deferred.resolve(types)
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  // getTotals(from, to, type, branchIds, accountIds, agentAccountIds, agentIds) {
  //   const deferred = this.$q.defer();
  //
  //   this.bringozLoaderService.on();
  //   this.surveyRequests.getTotals(from, to, type, branchIds, accountIds, agentAccountIds, agentIds)
  //     .then((totals) => {
  //       deferred.resolve(totals)
  //     })
  //     .catch((error) => {
  //       this.$log.error(error);
  //       // this.surveyAlerts.getTotalsError();
  //       deferred.reject(error)
  //     })
  //     .finally(() => {
  //       this.bringozLoaderService.off();
  //     });
  //
  //   return deferred.promise
  // }

  getTotals(from, to, type, branchIds, accountIds, agentAccountIds, agentIds) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.surveyRequests.getTotals(from, to, type, branchIds, accountIds, agentAccountIds, agentIds)
      .then((totals) => {
        deferred.resolve(totals)
      })
      .catch((error) => {
        this.$log.error(error);
        // this.surveyAlerts.getTotalsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportData( exportSurveyRequest: ExportSurveyRequestModel, branchIds: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.surveyRequests.exportData(exportSurveyRequest, branchIds)
      .then((totals) => {
        this.surveyAlerts.exportSuccess();
        deferred.resolve(totals)
      })
      .catch((error) => {
        this.$log.error(error);
        this.surveyAlerts.exportError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.survey')
  .service('surveyService', SurveyService);
